/**
 * @file コンポーネント：フル動画ページ概要 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Button } from "~/src/components/uiparts/Button";
import { List } from "~/src/components/uiparts/List";

// 関数読み込み
import { fnConvertLineStringToHtml } from "~/src/functions/common";

// スタイル読み込み
import {
    StyledContent,
    StyledContentDevice,
    StyledContentDeviceAnchor,
    StyledContentDeviceIcon,
    StyledContentDeviceName,
    StyledContentEdit,
    StyledContentEditLink,
    StyledContentEditLinkIcon,
    StyledContentEditLinkText,
    StyledContentItem,
    StyledContentParagraph,
    StyledContentSection,
    StyledContentSectionHeadline,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledContent>
            {/* 機器広告概要 */}
            {props.adOperationSummary !== null && (
                <>
                    <StyledContentParagraph
                        dangerouslySetInnerHTML={{
                            __html: props.adOperationSummary,
                        }}
                    />
                    {props.adOperationLink && (
                        <StyledContentItem>
                            <Button
                                buttonType="main"
                                href={props.adOperationLink}
                                icon={
                                    <i className="fas fa-external-link-alt"></i>
                                }
                                target="_blank"
                                text={localized["Label.More"]}
                            />
                        </StyledContentItem>
                    )}
                </>
            )}
            {/* 症例概要 */}
            <StyledContentParagraph
                dangerouslySetInnerHTML={{
                    __html: fnConvertLineStringToHtml(props.summary),
                }}
                ref={props.refSummary}
            />
            {props.isEditPage === true && (
                // 執刀医権限の場合のみ
                <StyledContentEdit>
                    <StyledContentEditLink
                        href="#"
                        onClick={(e) =>
                            props.fnSetModalEdit(e, "summary", "edit", {
                                context: props.refSummary.current.innerText,
                                languageCode: props.languageCodeOperation,
                                targets: [props.refSummary.current],
                                title: props.refTitle.current.innerText,
                            })
                        }
                    >
                        <StyledContentEditLinkIcon>
                            <i className="fas fa-edit"></i>
                        </StyledContentEditLinkIcon>
                        <StyledContentEditLinkText>
                            {localized["Label.Edit"]}
                        </StyledContentEditLinkText>
                    </StyledContentEditLink>
                </StyledContentEdit>
            )}
            {/* 機器リスト */}
            {props.listSurgicalEquipment.length > 0 && (
                <StyledContentSection>
                    <StyledContentSectionHeadline>
                        {localized["Label.Devices"]}
                    </StyledContentSectionHeadline>
                    <List
                        list={props.listSurgicalEquipment.map((item, index) => (
                            <StyledContentDevice key={"device-" + index}>
                                {item.link ? (
                                    // リンク有り
                                    <StyledContentDeviceAnchor
                                        href={item.link}
                                        target="_blank"
                                    >
                                        <StyledContentDeviceIcon>
                                            <i className="fas fa-external-link-alt"></i>
                                        </StyledContentDeviceIcon>
                                        <StyledContentDeviceName>
                                            {item.name}
                                        </StyledContentDeviceName>
                                    </StyledContentDeviceAnchor>
                                ) : (
                                    // リンク無し
                                    <StyledContentDeviceName>
                                        {item.name}
                                    </StyledContentDeviceName>
                                )}
                            </StyledContentDevice>
                        ))}
                        listStyleType="disc"
                        onColor="sub"
                    />
                </StyledContentSection>
            )}
        </StyledContent>
    );
};
